/*=================================================
    정규식을 반환
=================================================*/
import type { RegExType } from '@/types/RegExType';

/**
 *
 * @param type - 체크하려는 정규식 종류
 * @returns 정규식 반환
 */
export default function getRegExp(type: RegExType) {
  let regExp;

  switch (type) {
    case 'num':
      regExp = /^[0-9]*$/;
      break;
    case 'num_contain':
      regExp = /^.*(?=.*[0-9]).*$/;
      break;
    case 'dashnum':
      regExp = /^[0-9-]*$/;
      break;
    case 'low_eng':
      regExp = /^[a-z]*$/;
      break;
    case 'up_eng':
      regExp = /^[A-Z]*$/;
      break;
    case 'eng':
      regExp = /^[A-Za-z]*$/;
      break;
    case 'eng_contain':
      regExp = /^.*(?=.*[a-zA-Z]).*$/;
      break;
    case 'kor':
      regExp = /^[가-힇]*$/;
      break;
    case 'low_eng_num':
      regExp = /^[a-z0-9_]*$/;
      break;
    case 'up_eng_num':
      regExp = /^[A-Z0-9_]*$/;
      break;
    case 'eng_num':
      regExp = /^[A-Za-z0-9_]*$/;
      break;
    case 'eng_num_dash':
      regExp = /^[A-Za-z0-9_-]*$/;
      break;
    case 'nickname':
      regExp = /^[가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9]{1,12}$/;
      break;
    case 'email':
      regExp = /^([0-9a-zA-Z_.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
      break;
    case 'mobile':
      regExp = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
      break;
    case 'phone':
      regExp = /^\d{2,3}-\d{3,4}-\d{4}$/;
      break;
    case 'phone_num':
      regExp = /^\d{11}$/;
      break;
    case 'certificate_code':
      regExp = /^\d{4}$/;
      break;
    case 'url':
      regExp = /^http/;
      break;
    case 'password_en_num':
      //영어 숫자조합
      regExp = /^.*(?=.*[0-9])(?=.*[a-zA-Z]).*$/;
      break;
    case 'password_en_up_low_num_special':
      //영어 대문자, 소문자, 숫자, 특수문자
      regExp =
        /^.*(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[A-Z])(?=.*[~!@#$%^&*()_+|<>?:{}]).*$/;
      break;
    case 'password_en_num_special':
      //영어, 숫자, 특수문자
      regExp = /^.*(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[~!@#$%^&*()_+|<>?:{}]).*$/;
      break;
    case 'special':
      // 특수문자를 포함하는가
      regExp = /^.*(?=.*[~!@#$%^&*()_+|<>?:{}]).*$/;
      break;
    case 'link':
      regExp =
        /^(((http(s?)):\/\/)?)([0-9a-zA-Z-]+\.)+[a-zA-Z]{2,6}(:[0-9]+)?(\/\S*)?/;
      break;
    case 'http':
      regExp = /^http[s]?:\/\//i;
      break;
    case 'birth_date':
      regExp = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/i;
      break;
    case 'date':
      regExp = /^\d{4}.(0[1-9]|1[0-2]).(0[1-9]|[12][0-9]|3[01])$/i;
      break;
    default:
      regExp = /.*$/;
      break;
  }
  return regExp as RegExp;
}
